import React from 'react';
import { useTheme, useMediaQuery } from '@ublend-npm/aulaui-core';

interface ConversationModalResponsiveWrapperProps {
  children: React.ReactNode;
  viewParticipantsOpened: boolean;
  addParticipantOpened: boolean;
}

const ConversationModalResponsiveWrapper: React.FC<
  ConversationModalResponsiveWrapperProps
> = ({ children, viewParticipantsOpened, addParticipantOpened }) => {
  const theme = useTheme();
  const isLgUp = useMediaQuery(theme.breakpoints.up('lg'));

  // Hide content on small devices when viewing participants (but not when adding participants)
  if (!isLgUp && viewParticipantsOpened && !addParticipantOpened) {
    return null;
  }

  return <>{children}</>;
};

export default ConversationModalResponsiveWrapper;
